import { css } from 'styled-components';

export const richContentBodyStyles = css`
  color: inherit;
  font-size: inherit;
  line-height: inherit;
  overflow-x: auto;
  min-width: 0;

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #0f172a;
    line-height: 1.2;
    margin-top: 1.6em;
    margin-bottom: 0.65em;
  }

  h1 {
    font-size: 1.5em;
  }

  h2 {
    font-size: 1.35em;
  }

  h3 {
    font-size: 1.2em;
  }

  h4 {
    font-size: 1.08em;
  }

  p,
  ul,
  ol,
  pre,
  blockquote,
  table {
    margin: 0 0 1em 0;
  }

  ul,
  ol {
    padding-left: 1.5em;
  }

  li {
    margin: 0.25em 0;
  }

  a {
    color: #0f766e;
    text-decoration: underline;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 1.25em auto;
    border-radius: 18px;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  }

  table {
    width: max-content;
    min-width: 100%;
    border-collapse: collapse;
    border: 1px solid #cbd5e1;
    border-radius: 16px;
    background: #ffffff;
  }

  thead {
    background: #f8fafc;
  }

  th,
  td {
    padding: 12px 14px;
    border: 1px solid #dbe4ea;
    text-align: left;
    vertical-align: top;
  }

  th {
    color: #0f172a;
    font-weight: 700;
  }

  blockquote {
    border-left: 4px solid #2c9fa4;
    padding: 14px 0 14px 18px;
    color: #475569;
    background: #f8fafc;
    border-radius: 0 14px 14px 0;
  }

  code,
  .ql-code-block-container,
  .ql-code-block {
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
  }

  code {
    display: inline-block;
    padding: 0.16em 0.45em;
    border-radius: 8px;
    background: #e2e8f0;
    color: #0f172a;
    font-size: 0.92em;
    white-space: break-spaces;
  }

  pre,
  pre.ql-syntax,
  .ql-code-block-container {
    margin: 1.25em 0;
    padding: 18px 20px;
    border-radius: 18px;
    border: 1px solid #0f172a;
    background: #0f172a;
    color: #e2e8f0;
    overflow-x: auto;
    white-space: pre;
    tab-size: 4;
  }

  pre code,
  pre.ql-syntax code,
  .ql-code-block-container code {
    display: inline;
    padding: 0;
    border-radius: 0;
    background: transparent;
    color: inherit;
    font-size: inherit;
    white-space: inherit;
  }

  .ql-code-block-container {
    display: grid;
    gap: 0;
  }

  .ql-code-block {
    white-space: pre;
    overflow-wrap: normal;
    word-break: normal;
  }
`;
